import React, {Component} from 'react';

//css
import styles from '../../static/css/componentStyleModules/thanksButtonComponent.module.scss';

//controllerAPI
import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI';

//components
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent.js';

export default class ThanksButtonComponent extends Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }

    toggleThanksCheck = (event) => {
        event.stopPropagation();

        //post用のデータを作成
        let newData = this.props.thankData;
        newData.check = !(newData.check);

        //アニメーション用にボタンを記録
        const thanksButton = event.currentTarget;

        if(this.props.dataSending === false){   
          
            this.props.onRewriteBackData(newData);

            // if(newData.check){   
                              
            //     thanksButton.classList.remove(styles['unChecked']);
            //     thanksButton.classList.add(styles['checked']);
            // }else {

            //     thanksButton.classList.remove(styles['checked']);
            //     thanksButton.classList.add(styles['unChecked']);
            // } 

            this.changeAnimation(newData.check,thanksButton)


        }else{
            //データベースを更新
            ThanksControllerAPI.store(newData)
            .then((result) => {
                //表示元のデータを書き換える
                this.props.onRewriteBackData(result.data);
                
                // if(result.data.check){
                    
                //     thanksButton.classList.remove(styles['unChecked']);
                //     thanksButton.classList.add(styles['checked']);
                    
                // }else {
                //     thanksButton.classList.remove(styles['checked']);
                //     thanksButton.classList.add(styles['unChecked']);
                // } 
                this.changeAnimation(result.data.check,thanksButton)
                
            }).catch((error) => {
                console.log(error.message);
            })
        }
        
    }

    changeAnimation = (newState,targetNode) => {
        if(newState){   
            targetNode.classList.remove(styles['unChecked']);
            targetNode.classList.add(styles['checked']);
        }else {
            targetNode.classList.remove(styles['checked']);
            targetNode.classList.add(styles['unChecked']);
        } 
    }

    render() {
        const thanksIcon = (
            <div className={styles['iconArea']}>
              <SvgIconBaseComponent 
              image="facedHeart"
              fillColor={this.props.status ? 'hsl(6,77%,64%)' : '#999999'}
              />
            </div>
        )

        const buttonClass = () => {
            if(this.props.type === 'round'){
                return(styles['thanksCheckButton'] + ' ' + styles['roundThanksButton']);
            }else if(this.props.type === 'bar'){
                return(styles['thanksCheckButton']);
            }
        }
      
        return (
            <div className={buttonClass()}
            onClick={this.toggleThanksCheck}>
              {this.props.type === 'round' && thanksIcon}
            </div>
        )
    }
}

// Propsのデフォルト値
SvgIconBaseComponent.defaultProps = {
    status:false,
    color: '#4d4d4d',
    dataSending:true,  
};

